/**
 * created by lei lei on 2020/6/17
 * 趋势分析组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from "echarts-for-react";
import {Empty, Input, Radio, Select, Tabs} from "antd";
import {Row, Col, Button, Modal, Checkbox, message, DatePicker,} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import OrdinaryTrees from "../editor/OrdinaryTrees";
import moment from 'moment';
import * as Utils from "../../../utils";

const {Option} = Select;
const {MonthPicker, RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {Search} = Input;
const {TabPane} = Tabs;
let option = {
    title: {
        text: '单位：个',//头部文字显示
        left: 50,
        top: 23,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    legend: {
        bottom: 0,//提示定位
        left: 500,
        show: true,
        /* data: ['已发派', '已提交', '已完成', '进行中']*/
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        /*{
            name: '已发派',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#BFBFBF',
                    lineStyle:{
                        color:'#BFBFBF'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '已提交',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#FFBF00',
                    lineStyle:{
                        color:'#FFBF00'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '已完成',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#00A854',
                    lineStyle:{
                        color:'#00A854'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '进行中',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#0E77D1',
                    lineStyle:{
                        color:'#0E77D1'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },*/

    ]
};
export default class TrendAnalysis extends Component {
    static defaultProps = {
        isUpdate: false,
        numberSelected: 3,
    };
    static propTypes = {
        option: PropTypes.object.isRequired,//图表的数据来源这个是必须属性，但是加了会报错，数据必须传递
        topTimeBtnClick: PropTypes.func.isRequired,//顶部时间按钮点击后的回调
        topMarkNumBtnClick: PropTypes.func.isRequired,//顶部统计数按钮点击后的回调
        dataSource: PropTypes.array.isRequired,//弹出框下拉列表数据
        modalList: PropTypes.array.isRequired,//弹出框的个内容
        isUpdate: PropTypes.bool,//是否更新子组件
        modalItemKey: PropTypes.string.isRequired,// 弹出框内容的键值名称
        numberSelected: PropTypes.number.isRequired,//最多可选中个数
        companyCallback: PropTypes.func.isRequired,//选择单位的回调函数
        modalOkCallback: PropTypes.func.isRequired,//点击弹出框的确定的回调,
        mediaType: PropTypes.string.isRequired,//媒体类型必须值。

    };

    constructor(props) {
        super(props);
        this.state = {
            markNumText: '净增粉丝数',
            timeText: '7',
            colorList: ['#FFBF00', '#00A854', '#0E77D1', 'pink', 'green', 'red', 'blue', 'yellow', 'gray'],
            visible: false,
            columName: '',
            modalList: [],
            showStatue: false,
            searchText: '',
            startDate: null,// moment().add(-7, 'days').format(' YYYY-MM-DD') + ' 00:00:00',//开始时间
            endDate: null,//moment().format(' YYYY-MM-DD') + ' 00:00:00',//结束时间
            needUUid: true,//子组件是否更新
            departId: undefined,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    init(mediaType) {
        let markNumText;
        //下面的值和引用页dataChange 方法里面的key值一致。第一条默认key 键值
        if (mediaType === '2') {
            markNumText = 'massNumber';
        }
        if (mediaType === '3') {
            markNumText = 'totalFansAddCountYData';
        }
        if (mediaType === '5') {
            markNumText = 'totalFansAddCountYData';
        }
        this.setState({
            markNumText: markNumText,
            timeText: '7',
            needUUid: true,//子组件是否更新
            departId: undefined,
        })
        let data = {
            startDate: moment().add(-6, 'days'),//开始时间
            endDate: moment(),//结束时间
        }
        this.props.topTimeBtnClick && this.props.topTimeBtnClick(data);
        this.props.companyCallback && this.props.companyCallback(null);
        this.search('');
    }

    //点击描述按钮
    handleMarkNumChange = e => {
        this.setState({markNumText: e});
        this.props.topMarkNumBtnClick && this.props.topMarkNumBtnClick(e);
    };
    //点击时间按钮
    handleTimeTextChange = e => {
        let result = e.target.value;
        if (result != 'custom') {
            this.state.startDate = null;
            this.state.endDate = null;
        }
        this.setState({timeText: e.target.value});

        let data = {};
        if (result === '7') {
            data = {
                startDate: moment().add(-6, 'days'),//开始时间
                endDate: moment(),//结束时间
            }
        } else if (result === '15') {
            data = {
                startDate: moment().add(-14, 'days'),//开始时间
                endDate: moment(),//结束时间
            }
        } else if (result === '30') {
            data = {
                startDate: moment().add(-29, 'days'),//开始时间
                endDate: moment(),//结束时间
            }
        }


        this.props.topTimeBtnClick && this.props.topTimeBtnClick(data);
    };

    componentWillReceiveProps(nextProps, nextContext) {
        nextProps.modalList.forEach(item => {
            // item.checked = false;
            item.show = true;
        });
        if (nextProps.isUpdate) {
            this.setState({modalList: nextProps.modalList});
        }
    }

    getDistance(arr) {
        let b = 0.2;
        for (let i = 0; i < arr.length; i++) {
            if ((i + 1) % 10 === 0) {
                b += 0.2
            }
        }
        return b * 100 + "%";
    }

    disabledDate = (current) => {
        // 获取当前年份
        const currentYear = new Date().getFullYear();
        // 获取当前日期的年份
        const year = current.year();
        // 如果日期的年份小于当前年份，则禁用
        if (year !== currentYear) {
            return true;
        }
        // 其他情况允许选择日期
        return false;
    }

    render() {
        //接受图标参数
        option.xAxis.data = this.props.option.xData;
        let colorList = this.props.option.colorList ? this.props.option.colorList : this.state.colorList;
        option.series = [];
        this.props.option.yData.forEach((item, i) => {
            option.series.push(
                {
                    name: '',
                    type: 'line',
                    /* stack: '总量',*/
                    itemStyle: {
                        normal: {
                            color: colorList[i],
                            lineStyle: {
                                color: colorList[i]
                            }
                        }
                    },
                    data: [],
                    ...item
                }
            )
        });

        let distance = this.getDistance(this.props.option.yData);  //做适配
        option.grid = {
            containLabel: true,
            bottom: distance
        }
        option.legend = {
            bottom: 0
        }

        // 时间筛选前面的 粉丝类筛选，对应的是微信微博抖音对应字段的键值，
        // 2是微信，和引用页的mediaType 是一致的。切记保持一致字段对应准确
        let staticList = {
            '2': [
                {key: 'massNumber', value: '群发数'},
                {key: 'articleCount', value: '图文数'},
                {key: 'readNum', value: '阅读数'},
                {key: 'likeNum', value: '点赞数'},
                {key: 'inSight', value: '在看数'}],
            '3': [
                {key: 'totalFansAddCountYData', value: '净增粉丝'},
                {key: 'totalFansCountYData', value: '累积粉丝'},
                {key: 'totalPublishCountYData', value: '发布'},
                {key: 'totalPostCountYData', value: '转发'},
                {key: 'totalCommentCountYData', value: '评论'},
                {key: 'totalLikeCountYData', value: '点赞'}],
            '5': [
                {key: 'totalFansAddCountYData', value: '净增粉丝'},
                {key: 'totalFansCountYData', value: '累积粉丝'},
                {key: 'totalPublishCountYData', value: '发布'},
                {key: 'totalPostCountYData', value: '转发'},
                {key: 'totalCommentCountYData', value: '评论'},
                {key: 'totalLikeCountYData', value: '点赞'}]
        };
        let showSelectMediaData = false;
        if (this.state.modalList && this.state.modalList.length > 0 && this.state.modalList.find(item => item.show)) {
            showSelectMediaData = true;
        }
        return (
            <div className={'TrendAnalysis'} key={this.state.needUUid ? Utils.uuid() : 1} style={{padding: 20}}>
                <div style={{position: 'relative', height: "100%"}}>
                    <Row>
                        <Col span={8}>
                            <Tabs size={"small"} tabBarStyle={{width: 390, paddingTop: "3px"}} tabBarGutter={5} style={{height: "44px", lineHeight: "44px"}}
                                  activeKey={this.state.markNumText}
                                  onChange={this.handleMarkNumChange}>
                                {staticList[this.props.mediaType].map((item, i) => {
                                    return (
                                        <TabPane tab={item.value} key={item.key}/>
                                    )
                                })}
                            </Tabs>
                            <style>{`.TrendAnalysis .ant-tabs-bar{border-bottom: 0;}`}</style>
                        </Col>
                        <Col span={6}>
                            <Radio.Group style={{float: "right", height: "44px", lineHeight: "44px"}} value={this.state.timeText}
                                         onChange={this.handleTimeTextChange}>
                                <Radio.Button value="7">近7天</Radio.Button>
                                <Radio.Button value="15">近15天</Radio.Button>
                                <Radio.Button value="30">近30天</Radio.Button>
                            </Radio.Group>
                        </Col>
                        <Col span={7}>
                            <RangePicker value={[this.state.startDate, this.state.endDate]}
                                         format={dateFormat}
                                         disabledDate={this.disabledDate}
                                         style={{height: "44px", lineHeight: "44px", marginLeft: 24}}
                                         onChange={(date, dateString) => {
                                             if (date && date.length) {
                                                 this.state.timeText = '';
                                                 this.state.startDate = date[0];
                                                 this.state.endDate = date[1];
                                                 if (dateString[0] && dateString[1] && dateString[0] === dateString[1]) {
                                                     message.warning('开始时间和结束时间不能为同一天');
                                                     this.state.startDate = null;
                                                     this.state.endDate = null;
                                                     return;
                                                 }
                                                 if (!dateString[0]) {
                                                     this.state.startDate = null;
                                                 }
                                                 if (!dateString[1]) {
                                                     this.state.startDate = null;
                                                 }
                                                 if (dateString[0] && dateString[1]) {
                                                     let data = {
                                                         startDate: this.state.startDate,//开始时间
                                                         endDate: this.state.endDate,//结束时间
                                                     };
                                                     this.props.topTimeBtnClick && this.props.topTimeBtnClick(data)
                                                 }
                                             } else {
                                                 let data = {
                                                     startDate: moment().add(-6, 'days'),//开始时间
                                                     endDate: moment(),//结束时间
                                                 }
                                                 this.state.startDate = null;
                                                 this.state.endDate = null;
                                                 this.state.timeText = '7';
                                                 this.props.topTimeBtnClick && this.props.topTimeBtnClick(data)
                                             }
                                             this.setState({})
                                         }}
                            />
                        </Col>
                        <Col span={3}>
                            <div style={{height: "44px", lineHeight: "42px", marginLeft: "30px"}}>
                                <Button onClick={() => {
                                    this.initModalList()
                                    this.setState({
                                        needUUid: false,
                                        visible: true,
                                        searchText: '',
                                        departId: undefined,
                                    }, () => {
                                        this.props.companyCallback && this.props.companyCallback(null);
                                    });
                                }} type="primary">选择媒体</Button>
                            </div>

                        </Col>
                        <Modal
                            title="选择媒体"
                            visible={this.state.visible}
                            onOk={() => {
                                this.onOK();
                            }}
                            onCancel={() => {
                                this.setState({
                                    needUUid: true,
                                    visible: false,

                                });
                            }}
                            width={800}
                            key={1}
                        >
                            <Row>
                                <Col span={8}>
                                    <div style={{paddingLeft: 30}}>
                                        <div style={{
                                            width: 160, height: 30,
                                            lineHeight: '30px'
                                        }}>
                                            <Select
                                                value={this.state.departId}
                                                style={{width: '100%'}}
                                                placeholder="请选择单位"
                                                allowClear
                                                onChange={(e) => {
                                                    this.state.departId = e;
                                                    this.props.companyCallback && this.props.companyCallback(e)
                                                    this.setState({})
                                                }}>

                                                {/*<Option value={null}>请选择单位</Option>*/}
                                                {this.props.dataSource.map((item, i) => {
                                                    return (
                                                        <Option key={i} value={item.id}>{item.name}</Option>
                                                    )

                                                })

                                                }

                                            </Select></div>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div style={{paddingLeft: 30, paddingRight: 20}}>
                                        <Search
                                            style={{
                                                height: 30,
                                                lineHeight: '30px'
                                            }}
                                            placeholder="请输入媒体名称"
                                            enterButton="检索"
                                            size="default"
                                            value={this.state.searchText}
                                            onChange={(e) => {
                                                this.setState({
                                                    searchText: e.target.value
                                                });
                                            }}
                                            onSearch={value => {
                                                this.search(value);
                                            }}
                                        />
                                    </div>

                                </Col>
                                <Col span={4}>
                                    <div>
                                        <Button style={{
                                            height: 30,
                                            lineHeight: '30px'
                                        }} onClick={() => {
                                            this.revert();
                                        }} size={'default'} type="primary">重置</Button>
                                    </div>
                                </Col>
                            </Row>
                            <div style={{padding: "20px 20px 0px 20px"}}>
                                {showSelectMediaData ?
                                    <Scrollbars autoHide autoHeight autoHeightMax={445}>
                                        <div>
                                            {this.state.modalList && this.state.modalList.length > 0 && this.state.modalList.map((item, index) => {
                                                return (
                                                    <div key={index} onClick={() => {
                                                        this.clickChecked(item, index);
                                                    }} style={{
                                                        width: 220,
                                                        height: 50,
                                                        lineHeight: '50px',
                                                        border: '1px solid #ececec',
                                                        paddingLeft: 20,
                                                        float: 'left',
                                                        marginTop: 10,
                                                        marginLeft: 10,
                                                        display: item.show ? 'block' : 'none',
                                                    }}>
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-around",
                                                            alignItems: "center",
                                                            cursor: "pointer"
                                                        }}>
                                                            <div style={{marginRight: "5px"}}>
                                                                <Checkbox checked={item.checked}/>
                                                            </div>
                                                            <div style={{
                                                                width: "220px", overflow: 'hidden',
                                                                textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                                            }}
                                                                 title={item[this.props.modalItemKey]}>{item[this.props.modalItemKey]}</div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Scrollbars> : <Empty/>}
                            </div>
                        </Modal>
                    </Row>

                    <div style={{height: 340, width: '100%'}}>
                        <ReactEcharts
                            option={option}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />
                    </div>

                </div>
            </div>
        )
    }

    initModalList = () => {
        this.state.modalList && this.state.modalList.length && this.state.modalList.forEach((item => {
            item.show = true
        }))
        this.setState({})
    }

    //搜索
    search(value) {
        //获取搜索到的字符
        this.state.modalList.forEach(item => {
            if (item[this.props.modalItemKey].indexOf(value.trim()) > -1) {
                item.show = true;
            } else {
                item.show = false;
            }
        });
        this.setState({
            searchText: value,
        });
    }

    //重置
    revert() {
        this.state.departId = undefined;
        this.state.modalList = [];
        this.state.searchText = "";
        this.props.companyCallback && this.props.companyCallback(null);
    }

    //点击选择
    clickChecked(record, i) {
        this.state.modalList[i].checked = !record.checked;
        // let num = 0;
        // this.state.modalList.forEach(item => {
        //     if (item.checked) {
        //         num++;
        //     }
        // });
        // if (num > this.props.numberSelected) {
        //     record.checked = false;
        //     this.state.modalList[i].checked = false;
        //     // this.state.modalList[i].checked = !record.checked;
        //     message.error('最多只可选' + this.props.numberSelected + '个哦！');
        // }
        this.state.needUUid = false;
        if (this.state.searchText.trim().length > 0) {
            this.search(this.state.searchText);
        } else {
            this.setState({});
        }
    }

    //点击弹出框后的确定
    onOK() {
        let checkedList = [];
        this.state.modalList.forEach(item => {
            if (item.checked) {
                checkedList.push(item.code);
            }
        });
        this.setState({visible: false, needUUid: true});
        this.props.modalOkCallback && this.props.modalOkCallback(checkedList);
        // this.setState({visible: false, needUUid: true});
    }

}